"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (action) {
    var HeaderBrand = document.querySelector('.Header__brand');
    var HeaderState = document.querySelector('.Header.is-notTop');
    var homePage = document.querySelector('body.home');
    // If we can't find the brand
    if (!HeaderBrand || HeaderState || !homePage)
        return;
    if (action === 'shrink') {
        HeaderBrand.classList.add('shrink');
    }
    else {
        HeaderBrand.classList.remove('shrink');
    }
});
